export const IconArrowBorderSquare = (props) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_1183_5309)">
        <path
          d="M12.6693 14.6693H3.33594C2.22927 14.6693 1.33594 13.7759 1.33594 12.6693V3.33594C1.33594 2.22927 2.22927 1.33594 3.33594 1.33594H12.6693C13.7759 1.33594 14.6693 2.22927 14.6693 3.33594V12.6693C14.6693 13.7759 13.7759 14.6693 12.6693 14.6693Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.6693 5.33594L5.33594 10.6693"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.6693 10.6693V5.33594H5.33594"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1183_5309">
          <rect width="16" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
